import { store } from '@/app/shared/stores';

class CachedBuddyServiceClass {
  constructor() {
    // idk if this is the best solution here
    async function updateIfNeeded(lastFetch, dispatchName, ignoreCache = false) {
      const threeMinutesInSeconds = 180;
      const cachedUserGuid = store.state.buddy[`last${dispatchName}MemberGuid`];
      const sameUser = cachedUserGuid === store.state.user.userGuid;
      if (
        !sameUser
        || lastFetch === undefined
        || (new Date() - new Date(lastFetch)) / 1000 > threeMinutesInSeconds
        || ignoreCache
      ) {
        await store.dispatch(dispatchName);
      }
    }

    this.getBuddies = async (ignoreCache = false, includePending = false) => {
      await updateIfNeeded(store.state.buddy.lastFetchBuddies, 'updateBuddies', ignoreCache);

      if (includePending) {
        const pending = await this.getPendingBuddies(ignoreCache);
        const returnThing = [...pending, ...store.state.buddy.buddies];
        return returnThing;
      }
      return store.state.buddy.buddies;
    };

    this.getPendingBuddies = async (ignoreCache = false) => {
      await updateIfNeeded(store.state.buddy.lastFetchPending, 'updatePendingBuddies', ignoreCache);
      return store.state.buddy.pendingBuddies;
    };

    this.getBuddyRequests = async (ignoreCache = false, becauseBuddyJustAdded = false) => {
      await updateIfNeeded(store.state.buddy.lastFetchRequests, 'updateBuddyRequests', ignoreCache);
      if (becauseBuddyJustAdded) await updateIfNeeded(store.state.buddy.lastFetchBuddies, 'updateBuddies', ignoreCache);
      return store.state.buddy.buddyRequests;
    };

    this.getShareCode = async () => {
      if (store.state.buddy.shareCode === undefined) await store.dispatch('populateShareCode');
      return store.state.buddy.shareCode;
    };
  }
}

const CachedBuddyService = new CachedBuddyServiceClass();

export { CachedBuddyService };
